import { SceneLoader } from '@/ts/utils/webgl/core/sceneLoader';

import { BaseScene } from '@/ts/utils/webgl/core/baseScene';
import { SphereScene } from '@/ts/utils/webgl/scenes/sphere.scene';
import { MountainScene } from '@/ts/utils/webgl/scenes/mountains.scene';
import { ParticlesScene } from '@/ts/utils/webgl/scenes/particles.scene';

const scenes = {
    baseScene: BaseScene,
    sphereScene: SphereScene,
    mountainScene: MountainScene,
    particleScene: ParticlesScene,
};
export const sceneLoader = new SceneLoader(scenes);

sceneLoader.init();
sceneLoader.render();
